import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';

import { AuthService } from '../services/auth.service';

/** Rotas que não devem enviar Bearer (login/refresh) nem disparar novo refresh em 401. */
function isAuthExcludedUrl(url: string): boolean {
  return url.includes('/user/login') || url.includes('/user/refresh-token');
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const token = isAuthExcludedUrl(req.url) ? null : auth.getAccessToken();
  const outbound = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  return next(outbound).pipe(
    catchError((err: unknown) => {
      if (!(err instanceof HttpErrorResponse)) {
        return throwError(() => err);
      }
      if (!AuthService.isExpiredAccessTokenError(err)) {
        return throwError(() => err);
      }
      if (isAuthExcludedUrl(req.url)) {
        return throwError(() => err);
      }
      return from(auth.performTokenRefresh()).pipe(
        switchMap(() => {
          const newToken = auth.getAccessToken();
          if (!newToken) {
            return throwError(() => err);
          }
          const retryReq = req.clone({
            setHeaders: { Authorization: `Bearer ${newToken}` },
          });
          return next(retryReq);
        }),
        catchError(() => throwError(() => err)),
      );
    }),
  );
};
